import "./CoverImageDialog.scss";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import { API_RESPONSE, COMMON_CONSTANTS, I18_TRANSLATION_COMMON, NUMBER_CONSTANTS, PERSONAL_INFORMATION, SESSIONS_ERROR_MESSAGE, STORAGE_KEYS, TOASTER_CONFIGS } from "../../../../Utilities/Constants/Constants";
import { useEffect, useRef, useState } from "react";
import uploadImage from "../../../../../Assets/Registration/feather_upload-cloud-icon.svg";
import { toast } from "react-toastify";
import { REGISTRATION_ERRORS } from "../../../../Utilities/Constants/Validations";
import { GetSessionStorageData, S3DataGetApi, uploadFileToS3 } from "../../../../Services/Helpers/Helper";
import coverImageIcon from "../../../../../Assets/global/image-cover.svg";
import FileViewerDialog from "../../../../Shared/FileViewerDialog/FileViewerDialog";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import VideoPlayerDialog from "../../../../Shared/VideoPlayerDialog/VideoPlayerDialog";
import ConfirmationDialog from "../../../../Shared/ConfirmationDialog/ConfirmationDialog";
import { setLoader } from "../../../../Services/Redux/Reducer/Reducer";
import { store } from "../../../../Services/Redux/Store/Store";
import { useSelector } from "react-redux";

const CoverImageDialog = (props: any) => {
  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const uploadFileRef = useRef<HTMLInputElement | null>(null);
  const immigrantFrontBtnRef = useRef<HTMLInputElement | null>(null);
  const introVideoBtnRef = useRef<HTMLInputElement | null>(null);
  const [coverImage, setCoverImage] = useState<any>([]);
  const [viewerFile, setViewerFile] = useState("");
  const [introVideo, setIntroVideo] = useState<any>();
  const [fileViewerOpen, setFileViewerOpen] = useState(API_RESPONSE.FALSE);
  const dialogContent = SESSIONS_ERROR_MESSAGE.DELETE_ALERT;
  const [modalStatus, setmodalStatus] = useState(API_RESPONSE.FALSE);
  const aws: any = useSelector((state: any) => {
    return state.awsReducer.aws;
  });

  /* Handling drag over */
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (props)
      setCoverImage(props?.detail?.cover_images)
    setIntroVideo(props?.detail?.intro_video)
  }, [props])

  /* Handling file drag */
  const handleDragEnter = (event: any) => {
    event.preventDefault();
  };

  const [uploadType, setUploadType] = useState("");
  const [dropEvent, setDropEvent]: any = useState();
  const checkUploadType = (
    event: any,

    uploadingType: any
  ) => {
    setUploadType(uploadingType);
    return new Promise((resolve, reject) => {
      const eventValue: any =
        uploadingType === PERSONAL_INFORMATION.DROP
          ? event.dataTransfer.files
          : event.target.files;
      const isValid: any = [...eventValue].every((media: any) => {
        if (
          media.type.split("/")[NUMBER_CONSTANTS.ONE] ===
          COMMON_CONSTANTS.PDF ||
          media.type.split("/")[NUMBER_CONSTANTS.ZERO] ===
          COMMON_CONSTANTS.IMAGE
        ) {
          return API_RESPONSE.TRUE;
        }
        return API_RESPONSE.FALSE;
      });

      if (isValid) {
        resolve(API_RESPONSE.TRUE);
      } else {
        reject(API_RESPONSE.FALSE);
      }
    });
  };

  /* Handling file drop */
  const handleDrop = (event: any) => {
    store.dispatch(setLoader(true));
    event.preventDefault();
    event.nativeEvent.preventDefault();
    checkUploadType(event, PERSONAL_INFORMATION.DROP)
      .then((status) => {
        // setCurrentUpload(uploadValue);
        // setUploadType(PERSONAL_INFORMATION.DROP);
        setDropEvent(event);
        store.dispatch(setLoader(false));
      })
      .catch((error) => {
        toast.error(error);
        store.dispatch(setLoader(false));
        // toast.error('Please upload valid format');
      });
  };

  /* Handling file drop */
  const handleDropVideo = (event: any) => {
    event.preventDefault();
    event.nativeEvent.preventDefault();
    store.dispatch(setLoader(true));
    checkUploadType(event, PERSONAL_INFORMATION.DROP)
      .then((status) => {
        // setCurrentUpload(uploadValue);
        // setUploadType(PERSONAL_INFORMATION.DROP);
        setDropEvent(event);
        store.dispatch(setLoader(false));
      })
      .catch((error) => {
        toast.error(error);
        store.dispatch(setLoader(false));
        // toast.error('Please upload valid format');
      });
  };

  /* Handling file drag leave */
  const handleDragLeave = (event: any) => {
    event.preventDefault();
  };

  /* Handle File change */
  const handleChange = (event: any) => {
    store.dispatch(setLoader(true));
    event.preventDefault();
    event.nativeEvent.preventDefault();
    checkUploadType(event, PERSONAL_INFORMATION.SELECT)
      .then((status) => {
        setDropEvent(event);
        store.dispatch(setLoader(false));
      })
      .catch((error) => {
        toast.error(error);
        store.dispatch(setLoader(false));
        // toast.error('Please upload valid format');
      });
  };

  useEffect(() => {
  }, [introVideo])
  /* Handle File change */
  const handleVideoChange = async (event: any) => {
    store.dispatch(setLoader(true));
    event.preventDefault();
    event.nativeEvent.preventDefault();
    // uploadFiles(event.target?.files[NUMBER_CONSTANTS.ZERO])
    const uploadedImage: any = await S3DataGetApi(event);
    setIntroVideo(uploadedImage)
    store.dispatch(setLoader(false));
    /* checkUploadType(event, PERSONAL_INFORMATION.SELECT)
      .then((status) => {
        setDropEvent(event);
      })
      .catch((error) => {
        toast.error(error);
        // toast.error('Please upload valid format');
      }); */
  };

  /* Media upload function */
  const uploadFiles = async (file: any) => {
    store.dispatch(setLoader(true));
    const uploadedImage: any = await S3DataGetApi(file);
    coverImage ?
      setCoverImage([...coverImage, uploadedImage]) :
      setCoverImage([uploadedImage])
    store.dispatch(setLoader(false));
  };

  const onDeleteImage = (id: any) => {
    let data = coverImage;
    data.splice(id, NUMBER_CONSTANTS.ONE);
    setCoverImage([...data])
  }

  useEffect(() => {
    if (dropEvent) {
      uploadType === PERSONAL_INFORMATION.DROP
        ? uploadFiles(dropEvent)
        : uploadFiles(dropEvent);
    }
  }, [dropEvent]);

  useEffect(() => {
  }, [coverImage])

  /**Handle file viewer dialog close */
  const onFilerViewerDialogClose = () => {
    setFileViewerOpen(API_RESPONSE.FALSE);
    setViewerFile("");
  };

  /**Handle file viewer dialog open */
  const onFilerViewerDialogOpen = (url: any) => {
    setViewerFile(url);
    setFileViewerOpen(API_RESPONSE.TRUE);
  };

  const onSubmit = () => {
    let payload = {
      cover_images: coverImage ? coverImage : "",
      profile: props?.detail?.profile,
      intro_video: introVideo ? introVideo : ""
    }
    if (coverImage?.length > NUMBER_CONSTANTS.ZERO, payload) {
      axiosInstance.put(API_END_POINTS.COVER_IMAGE, payload).then((response) => {
        toast.success(response.data.message, TOASTER_CONFIGS);
        props.handleClose();
      });
    }
  };

  const onCloseDialog = (status: any) => {
    if (status === API_RESPONSE.TRUE) {
      setIntroVideo("");
      setCoverImage([]);
      setmodalStatus(API_RESPONSE.FALSE)
      props.handleClose();
    } else {
      setmodalStatus(API_RESPONSE.FALSE);
      // props.handleClose();
    }

  }

  const onVideoPlayerDialogOpen = (url: any) => {
    setIntroVideo(url);
    setVideoPlayerOpen(API_RESPONSE.TRUE);
  };

  const [videoPlayerOpen, setVideoPlayerOpen] = useState(false);

  /**Handle video player close */
  const onVideoPlayerDialogClose = () => {
    setVideoPlayerOpen(false);
  }

  return (
    <div className="cover-image-wrapper">
      <Dialog open={props.open}
      >
        <FileViewerDialog
          open={fileViewerOpen}
          handleClose={onFilerViewerDialogClose}
          viewerFile={viewerFile}
        ></FileViewerDialog>
        <VideoPlayerDialog
          open={videoPlayerOpen}
          handleClose={onVideoPlayerDialogClose}
          viewerFile={introVideo}
        ></VideoPlayerDialog>
        <ConfirmationDialog
          content={dialogContent}
          modalState={modalStatus}
          dialogStatus={onCloseDialog}
        />
        <div className="dialog-close-icon">
          <CloseIcon onClick={props.handleClose} />
        </div>

        <p className="dialog-form-label">Upload Cover Image</p>
        <DialogContent>
          <div className="dialog-form-items">
            <div
              className="id-upload-file-wrapper"
              onDragOver={handleDragOver}
              onDrop={(e: any) => {
                handleDrop(e);
              }}
              onDragEnter={handleDragEnter}
              onDragLeave={handleDragLeave}
              ref={uploadFileRef}
            >
              <div className="upload-content">
                <img src={uploadImage} />
                <div className="text-content">
                  <p className="select-text">Drag files here</p>
                </div>
                <input
                  type="file"
                  accept="image/png, image/jpg, image/jpeg, image/svg"
                  className="input-upload"
                  multiple={true}
                  onChange={(e: any) => {
                    handleChange(
                      e
                    );
                  }}
                  ref={immigrantFrontBtnRef}
                  style={{ display: "none" }}
                />
              </div>
              <button
                className="select-file-btn"
                onClick={() => {
                  immigrantFrontBtnRef.current?.click();
                }}
              >
                SELECT FILE
              </button>
            </div>
            {/* <div className="errorMessage">
                          {!immigrant_front && submitted && (
                            <p>{t(`${REGISTRATION_ERRORS.IMMIGRANT_FRONT}`)}</p>
                          )}
                        </div> */}
            <p className="recommanded-text">Recommended size: 800x533 with JPG,PNG</p>

            {coverImage?.length > NUMBER_CONSTANTS.ZERO && <div>
              <p className="file-added-text">File Added:</p>
              {coverImage?.map((image: any, index: any) => {
                return (
                  <div className="image-list" key={index + 1}>
                    <div className="image-text-wrap">
                      <img src={coverImageIcon} />
                      <p>{image.split("/")[image.split("/")?.length - 1]}</p>.
                      <p className="preview-text" onClick={() => {
                        onFilerViewerDialogOpen(image);
                      }}>preview</p>
                    </div>
                    <div>
                      <CloseIcon className="closeIcon" onClick={() => { onDeleteImage(index) }} />
                    </div>


                  </div>
                )
              })}
            </div>}

            {/* <div className="dialog-button-wrapper">
                            <button className="btn btn-secondary" onClick={props.handleClose}>Cancel</button>
                            <button className="btn btn-primary" onClick={onSubmit}>Submit</button>
                        </div> */}
          </div>
          {GetSessionStorageData(STORAGE_KEYS.ROLE) == NUMBER_CONSTANTS.FOUR && (
            <>
              <p className="dialog-form-label mt-3">Upload Introduction Video</p>
              <div className="dialog-form-items">
                <div
                  className="id-upload-file-wrapper"
                  onDragOver={handleDragOver}
                  onDrop={(e: any) => {
                    handleDropVideo(e);
                  }}
                  onDragEnter={handleDragEnter}
                  onDragLeave={handleDragLeave}
                  ref={uploadFileRef}
                >
                  <div className="upload-content">
                    <img src={uploadImage} />
                    <div className="text-content">
                      <p className="select-text">Drag files here</p>
                    </div>
                    <input
                      type="file"
                      accept="video/*"
                      className="input-upload"
                      multiple={true}
                      onChange={(e: any) => {
                        handleVideoChange(
                          e
                        );
                      }}
                      ref={introVideoBtnRef}
                      style={{ display: "none" }}
                    />
                  </div>
                  <button
                    className="select-file-btn"
                    onClick={() => {
                      introVideoBtnRef.current?.click();
                    }}
                  >
                    SELECT FILE
                  </button>
                </div>

                {introVideo && <div>
                  <p className="file-added-text">File Added:</p>
                  <div className="image-list" >
                    <div className="image-text-wrap">
                      <img src={coverImageIcon} />
                      <p>{introVideo.split("/")[introVideo.split("/")?.length - 1]}</p>.
                      <p className="preview-text" onClick={() => {
                        onVideoPlayerDialogOpen(introVideo);
                      }}>preview</p>
                    </div>
                    <div>
                      <CloseIcon className="closeIcon" onClick={() => setIntroVideo("")} />
                    </div>
                  </div>
                </div>}
              </div>
            </>
          )}
          <div className="dialog-button-wrapper">
            <button className="btn btn-secondary" onClick={() => { setmodalStatus(API_RESPONSE.TRUE) }}>Cancel</button>
            <button className="btn btn-primary" onClick={onSubmit}>Submit</button>
          </div>

        </DialogContent>

      </Dialog>
    </div>
  )
};

export default CoverImageDialog;